import React from 'react'
import VendorMapDetails from './../components/VendorMapDetails'

const VendorMap = () => {
	return (
		<div className="mt-5">
			<VendorMapDetails/>
		</div>
	)
}

export default VendorMap